import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialConfig = {
  urlState: {
    linkId: '',
    testFlowId: '',
    offeringName: '',
    accessConfigName: '',
    rrpConfigName: '',
    initialValues: {},
    lang: 'en',
    direction: 'ltr',
  },
  requiredRegistrationProperties: {
    data: undefined,
    isLoaded: false,
  },
  accessConfig: {
    data: undefined,
    isLoaded: false,
  },
  organizationConfig: {
    data: undefined,
    isLoaded: false,
  },
  testFlow: {
    data: undefined,
    isLoaded: false,
  },
  linkInfo: {
    data: undefined,
    isLoaded: false,
  },
  manifest: {
    data: undefined,
    isLoaded: false,
  },
  locale: {
    data: null,
    isLoaded: false,
  },
  dynamicConfig: {
    data: undefined,
    isLoaded: false,
  },
};

const configModule = {
  namespaced: true,
  state: {
    ...initialConfig,
  },
  mutations,
  actions,
  getters,
};

export default configModule;
